import { filter, head, pipe, sort } from 'ramda';

const dateDiff = (a: Date, b: Date) => new Date(a).getTime() - new Date(b).getTime();
export const getMaxDate = pipe(filter(Boolean), sort(dateDiff), head);
